

<mat-tab-group style="margin-top:30px;margin-left:10px;margin-right:10px;">
    <mat-tab label="Invoice">
        <app-find-by-invoice-number></app-find-by-invoice-number>
    </mat-tab>
    <mat-tab label="Parker">

    </mat-tab>
    <mat-tab label="Company">

    </mat-tab>
  </mat-tab-group>
